<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { onMount } from 'svelte';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOSetState } from '../../../../../js/ycapp';
import _ from 'lodash';
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'SPORTSALLIANCE') : null) || false;
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "https://id.sportsalliance.com/oidc/v1";
$: clubId = encodeURIComponent((clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clubId) || "");
$: clientId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clientId) || "";
$: clientIdParam = encodeURIComponent(clientId);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || new URL("/modals/en/KOREOpenIDRedirect", document.baseURI).href;
$: redirectUriParam = encodeURIComponent(redirectUri);
$: scope = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.scope) || "openid profile email phone address sso:user:manage sso:register:lite offline_access";
$: scopeParam = encodeURIComponent(scope);
$: nextPage = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.nextPage) || undefined;
$: nextPageExistingAccount = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.nextPageExistingAccount) || undefined;
$: endWorkflowExistingAccount = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.endWorkflowExistingAccount) || undefined;
$: endWorkflow = (_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.endWorkflow;
$: skipSetState = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.skipSetState) || false;
$: appIdOverride = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.appIdOverride) || undefined;
onMount(() => __awaiter(void 0, void 0, void 0, function* () {
    function afterConnect(existingAccount) {
        if (existingAccount && nextPageExistingAccount) {
            resolveUrl(nextPageExistingAccount).func();
        }
        else if (endWorkflow || (existingAccount && endWorkflowExistingAccount)) {
            signonManager.fireWorkflowEndEvent();
        }
        else if (nextPage) {
            resolveUrl(nextPage).func();
        }
        else if (signonManager.skipCompleteProfilePage) {
            resolveUrl(`ConnectAccounts`).func();
        }
        else {
            resolveUrl(`CompleteProfile`).func();
        }
    }
    if (connected) {
        afterConnect(false);
        return;
    }
    const codeVerifier = signonManager.generatePKCECodeVerifier();
    const challenge = yield signonManager.generatePKCEChallenge(codeVerifier);
    window.localStorage.setItem('KOREOpenIDCodeVerifier', codeVerifier);
    const state = 'yinzcam';
    const tpaConfig = Object.assign({ url: `${baseUri}/${clubId}/connect/authorize?client_id=${clientIdParam}&scope=${scopeParam}&response_type=code&redirect_uri=${redirectUriParam}&code_challenge=${challenge}&code_challenge_method=S256&state=${state}`, redirectUri }, ((!_.isNil(clientConfig.ephemeral)) ? { ephemeral: clientConfig.ephemeral } : undefined));
    ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j;
        console.log("ycSSOThirdPartyAuth callback inside OAUTH (KOREOpenID)", method, clientResult);
        const codeVerifier = window.localStorage.getItem('KOREOpenIDCodeVerifier');
        window.localStorage.removeItem('KOREOpenIDCodeVerifier');
        if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
            console.error('Client Error: ' + clientResult.error);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.redirectUri)) {
            console.warn(`ycSSOThirdPartyAuth callback for OAUTH (KOREOpenID): missing redirectUri`);
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const redirectParams = new URL(clientResult.redirectUri).searchParams;
        const checkState = redirectParams.get('state');
        if (checkState !== state) {
            alert("Missing or invalid KORE OpenID response.");
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const code = redirectParams.get('code');
        if (!code || !codeVerifier) {
            alert("Missing or invalid KORE OpenID response.");
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const tokens = yield signonManager.exchangeCodeForToken(`${baseUri}/${clubId}/connect/token`, clientId, scope, redirectUri, code, codeVerifier);
        const result = yield signonManager.loginWithSportsAllianceTokens(tokens.id_token, tokens.access_token, tokens.refresh_token, appIdOverride);
        if (!result.success) {
            alert(((_j = (_h = result.data) === null || _h === void 0 ? void 0 : _h.UserMessage) === null || _j === void 0 ? void 0 : _j.Content) || 'An error occurred validating your club credentials.');
            signonManager.fireWorkflowEndEvent();
            return;
        }
        const existingAccount = result.data.AccountCreated !== 'true';
        if (!skipSetState) {
            ycSSOSetState(!existingAccount, result.data.YinzId, parseInt(result.data.ValidSpan), result.data.Ticket);
        }
        afterConnect(existingAccount);
    }));
}));
</script>

<CardBase {element}>
</CardBase>
